/* Hero tile films: load the cut that fits the tile, play only while on screen,
   stay still for reduced motion, and honour the pause button. */
(function () {
  /* Both the hero tiles and the flagship feed load this file, and the home page
     carries both, so without a guard every film got two observers and two sets
     of listeners (23 Sep). */
  if (window.__meridianHeroTiles) return;
  window.__meridianHeroTiles = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-htile-video]').forEach(function (video) {
    var tile = video.closest('.htile');
    var toggle = tile.querySelector('[data-htile-toggle]');
    var mq = video.dataset.portraitMq ? window.matchMedia(video.dataset.portraitMq) : null;
    var userPaused = reduce.matches;
    var onScreen = false;

    function pick() {
      var portrait = mq && mq.matches;
      var src = portrait && video.dataset.srcPortrait ? video.dataset.srcPortrait : video.dataset.src;
      var poster = portrait && video.dataset.posterPortrait ? video.dataset.posterPortrait : video.dataset.poster;
      if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
      if (video.getAttribute('src') !== src) {
        video.setAttribute('src', src);
        if (onScreen && !userPaused) video.play().catch(function () {});
      }
    }

    function setPaused(paused) {
      tile.classList.toggle('is-paused', paused);
      if (toggle) toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    }

    function sync() {
      if (onScreen && !userPaused) {
        if (!video.getAttribute('src')) pick();
        video.play().catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
      setPaused(userPaused);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        sync();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.15 }).observe(tile);
    } else {
      onScreen = true;
      sync();
    }

    if (mq) {
      pick();
      if (mq.addEventListener) mq.addEventListener('change', pick);
    }
    function onMotion() { userPaused = reduce.matches; sync(); }
    if (reduce.addEventListener) reduce.addEventListener('change', onMotion);
    setPaused(userPaused);
  });

  /* ---------- showcase parallax ----------
     The film this replaces zoomed about 3% over six seconds and back, which
     read as an unexplained wobble: too small to be a camera move, too large to
     go unnoticed, and with nothing in an empty frame to reference it against.
     This moves the two products by different amounts as the reader scrolls, so
     the motion has a cause they can feel, and the difference in travel is what
     gives two flat cut-outs the depth to read as one scene.

     Offsets are written to a custom property on the item; the hover lift lives
     on the art inside it, so the two transforms never overwrite each other. */
  (function showcaseParallax() {
    var stages = [].slice.call(document.querySelectorAll('[data-showcase]'));
    if (!stages.length || reduce.matches) return;

    var travel = [18, 40]; // px, first item then second: different depths
    var ticking = false;

    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      stages.forEach(function (stage) {
        var r = stage.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        /* -1 below the fold, 0 centred, 1 gone past the top */
        var centre = r.top + r.height / 2;
        var p = (vh / 2 - centre) / (vh / 2 + r.height / 2);
        if (p < -1) p = -1; else if (p > 1) p = 1;
        var items = stage.querySelectorAll('[data-showcase-item]');
        for (var i = 0; i < items.length; i++) {
          var d = travel[i] === undefined ? travel[travel.length - 1] : travel[i];
          items[i].style.setProperty('--py', Math.round(p * -d * 10) / 10 + 'px');
        }
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();

    /* Someone turning reduced motion on mid-visit gets the offsets removed. */
    function onMotionPref() {
      if (!reduce.matches) return;
      window.removeEventListener('scroll', onScroll);
      stages.forEach(function (stage) {
        stage.querySelectorAll('[data-showcase-item]').forEach(function (el) {
          el.style.removeProperty('--py');
        });
      });
    }
    if (reduce.addEventListener) reduce.addEventListener('change', onMotionPref);
  })();
})();
